function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { RANGES } from "../views/sales/territory-common";
import ComparisonPicker from "./comparison-picker";
import RangePicker from "./range-picker";
import { compLabel } from "../functions/comp-label";
import { getGlobalRange, getGlobalComp, setGlobalRange, setGlobalComp, subscribePeriod, unsubscribePeriod } from "../functions/period-store";

// Top-bar global period + comparison control. Writes to the shared period
// store (localStorage + PubSub); every analytics page reads from the store
// and reloads on change, so the selected window persists across navigation.
export default class GlobalPeriodControl extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      range: getGlobalRange(),
      comp: getGlobalComp(),
      open: false
    });
    _defineProperty(this, "onRange", e => setGlobalRange(e.target.value));
    _defineProperty(this, "onComp", e => {
      const comp = e && e.detail && e.detail.item && e.detail.item.dataset && e.detail.item.dataset.value;
      if (comp && comp !== "unavailable") setGlobalComp(comp);
    });
  }
  componentDidMount() {
    this._tok = subscribePeriod(({
      range,
      comp
    }) => this.setState({
      range,
      comp
    }));
  }
  componentWillUnmount() {
    unsubscribePeriod(this._tok);
  }
  render() {
    // Phone widths (CSS-gated ≤767px): the inline pickers collapse to ONE
    // button whose popover carries the SAME two controls — Range + Trend
    // Comparison 1:1, nothing dropped (mobile-header plan, 2026-10-13).
    return /*#__PURE__*/React.createElement("span", {
      className: "global-period"
    }, /*#__PURE__*/React.createElement("span", {
      className: "gp-inline"
    }, /*#__PURE__*/React.createElement(ComparisonPicker, {
      id: "global-comp-menu",
      onSelected: this.onComp,
      selection: compLabel(this.state.comp)
    }), /*#__PURE__*/React.createElement(RangePicker, {
      value: this.state.range,
      ranges: RANGES,
      onChange: v => setGlobalRange(v)
    })), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "gp-compact",
      title: "Date range and comparison",
      onClick: () => this.setState({
        open: !this.state.open
      })
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "tune")), this.state.open && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "gp-pop-back",
      onClick: () => this.setState({
        open: false
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: "gp-pop"
    }, /*#__PURE__*/React.createElement("div", {
      className: "gp-row"
    }, /*#__PURE__*/React.createElement("span", {
      className: "gp-lbl"
    }, "Date range"), /*#__PURE__*/React.createElement(RangePicker, {
      value: this.state.range,
      ranges: RANGES,
      onChange: v => setGlobalRange(v)
    })), /*#__PURE__*/React.createElement("div", {
      className: "gp-row"
    }, /*#__PURE__*/React.createElement("span", {
      className: "gp-lbl"
    }, "Trend comparison"), /*#__PURE__*/React.createElement(ComparisonPicker, {
      id: "global-comp-menu-m",
      onSelected: this.onComp,
      selection: compLabel(this.state.comp)
    })))));
  }
}